/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */

export const CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD'

const updateLocation = (method) => {
    return (...args) => ({
        type: CALL_HISTORY_METHOD,
        payload: {
            method,
            args
        }
    })
};

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
export const push = updateLocation('push');
export const replace = updateLocation('replace');
export const go = updateLocation('go');
export const goBack = updateLocation('goBack');
export const goForward = updateLocation('goForward');

export const routerActions = { push, replace, go, goBack, goForward };

const routerMiddleware = (history) => store => next => action => { // eslint-disable-line no-unused-vars
    if (action.type !== CALL_HISTORY_METHOD) {
        return next(action)
    }

    const { payload: { method, args } } = action;
    history[method](...args);

    return next(action)
};


export default routerMiddleware
